import { render, staticRenderFns } from "./headerTitle.vue?vue&type=template&id=630a3746&scoped=true&"
import script from "./headerTitle.vue?vue&type=script&lang=ts&"
export * from "./headerTitle.vue?vue&type=script&lang=ts&"
import style0 from "./headerTitle.vue?vue&type=style&index=0&id=630a3746&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a3746",
  null
  
)

export default component.exports